import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Toasted from 'vue-toasted'
const env = process.env.NODE_ENV
const config = require(`../../config/${env}.env.js`)
console.log('env config:', config)
console.log('ROOT_API:', config.ROOT_API)
Vue.use(Toasted, {
  theme: 'bubble',
  position: 'top-right',
  duration: 5000,
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    vendor: localStorage.getItem('vendor') || null,
    rootApi: config.ROOT_API,
    siteUrl: config.SITE_URL,
    userData: {
      step: '',
      detectedVendor: '',
      selectedVendor: '',
      max_loan_amount: '',
      year: '',
      make: '',
      model: '',
      trim: '',
      vehicleStyle: '',
      carDetails: '',
      odometerReading: '',
      vin: '',
      selectedRepair: '',
      repairOfferAmount: '',
      cashBack: '',
      marketValue: '',
      dataCertainty: '',
      loanRequested: '',
      approvedLoanAmount: '',
      boundaryAmount: '',
      payment: 0,
      paymentFrequency: 3,
      paymentPeriod: '',
      numberOfPayments: 12,
      paymentTotal: 0,
      paymentFees: 0,
      loanApr: 0,
      newAPR: '',
      vendorToPay: '',
      firstPaymentDay: '',
      totalPayments: '',
      costOfFinancing: '',
      frequencyOfPayments: '',
      frequencyText: '',
      term: '',
      metric: 'km',
      vinFail: false,
      registered: false,
      title: false,
      sline: false,
      vendor: '',
      selectedProduct: '',
      productPrice: '',
    },
  },
  actions: {
    async fetchVendorsById({ commit }, ids) {
      try {
        // ids can be an array or a string
        const idsParam = Array.isArray(ids) ? ids.join(',') : String(ids || '')
        if (!idsParam) throw new Error('Missing vendor ids')

        const { data } = await axios.get(
          `${process.env.ROOT_API}/api/public/vendorbyid`,
          { params: { ids: idsParam } } // -> /api/public/vendorbyid?ids=id1,id2
        )

        return data
      } catch (error) {
        Vue.toasted.show('An error occurred while fetching vendor locations, please try again')
        console.error('Error fetching vendors by id:', error)
        throw error
      }
    },
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js